import { register, getPrefix } from '../../../Utils'

const ImageGallery = el => {
  const prefix = getPrefix(el)
  const galleryTitle = el.dataset.galleryTitle || '&nbsp;'

  const initSlider = () => {
    let Splide = window.Splide
    const sliderContainer = el.querySelector(`.${prefix}carousel-wrapper`)
    let sliderWidth = el.querySelector(`.${prefix}infobox`).offsetWidth

    const mainSlider = new Splide(sliderContainer, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      speed: 800,
      autoHeight: true,
      updateOnMove: true,
      waitForTransition: false,
      focus: 'center',
      pagination: false,
      fixedWidth: `${sliderWidth}px`
    })

    mainSlider.mount()

    const slideSum = ('0' + mainSlider.length).slice(-2)
    const countCountainer = el.querySelector(`.${prefix}counter`)
    const titleContainer = el.querySelector(`.${prefix}title`)
    const descriptionContainer = el.querySelector(`.${prefix}description`)

    let counterText = `01/${slideSum}`
    countCountainer.innerText = counterText

    const slideChange = (newSlide) => {
      if (!newSlide.isClone) {
        descriptionContainer.classList.add(`${prefix}is--hidden`)
        titleContainer.classList.add(`${prefix}is--hidden`)

        setTimeout(() => {
          titleContainer.innerHTML = newSlide.slide.dataset.title ? newSlide.slide.dataset.title : galleryTitle
          descriptionContainer.innerHTML = newSlide.slide.dataset.description

          descriptionContainer.classList.remove(`${prefix}is--hidden`)
          titleContainer.classList.remove(`${prefix}is--hidden`)
        }, 300)

        counterText = `${('0' + (newSlide.index + 1)).slice(-2)}/${slideSum}`
        countCountainer.innerText = counterText
      }
    }

    mainSlider.on('active', slideChange)
  }

  initSlider()
}

register('ImageGallery', ImageGallery)
